export default __webpack_public_path__ + "static/ehv-hair-treatment-2f391eb86fcfe79cda161c26a36e10a8.webp";